export interface TableSettings {
  // Design settings
  feltColor: string;
  backgroundDesign: string;
  deckDesign: string;
  tableTabsInDesktopEnabled: boolean;
  fannedCardsDisplayEnabled?: boolean;

  // Gameplay settings
  currentHandValueEnabled: boolean;
  autoTimeBankEnabled: boolean;
  runItTwiceEnabled: boolean;

  // Display settings
  stackInBigBlindsEnabled: boolean;
  chipsInBigBlindsEnabled: boolean;
  animationsEnabled: boolean;
  autoMuckCardsEnabled: boolean;
  displayFoldedCardsEnabled: boolean;
  allInEquityValueEnabled: boolean;
  modelsEnabled: boolean;
  showRealNameEnabled: boolean;

  // Sound settings
  soundEnabled: boolean;

  // Betting settings
  stepInBigBlindsEnabled: boolean;

  // Quick actions settings
  buttonConfigurations: QuickActionButtons;

  // Hotkeys settings
  hotkeys: Hotkeys;
}

export interface Hotkeys {
  betOrRaise: HotkeysBindings;
  bringIn: HotkeysBindings;
  call: HotkeysBindings;
  check: HotkeysBindings;
  complete: HotkeysBindings;
  confirm: HotkeysBindings;
  fold: HotkeysBindings;
}

export type HotkeysActions = keyof Hotkeys;

export const hotkeysActions: HotkeysActions[] = [
  'betOrRaise',
  'bringIn',
  'call',
  'check',
  'complete',
  'confirm',
  'fold',
];

export interface QuickActionButtons {
  onBetButtons: ButtonConfiguration[];
  onPreFlopButtons: ButtonConfiguration[];
  postFlopButtons: ButtonConfiguration[];
}

export interface ButtonConfiguration {
  value: number;
}

export interface HotkeysBindings {
  keys: string[];
  ctrl: boolean;
  meta: boolean;
}

export enum TableSettingsFields {
  FeltColor = 'feltColor',
  BackgroundDesign = 'backgroundDesign',
  DeckDesign = 'deckDesign',
  CurrentHandValueEnabled = 'currentHandValueEnabled',
  AutoTimeBankEnabled = 'autoTimeBankEnabled',
  RunItTwiceEnabled = 'runItTwiceEnabled',
  StackInBigBlindsEnabled = 'stackInBigBlindsEnabled',
  ChipsInBigBlindsEnabled = 'chipsInBigBlindsEnabled',
  AnimationsEnabled = 'animationsEnabled',
  AutoMuckCardsEnabled = 'autoMuckCardsEnabled',
  DisplayFoldedCardsEnabled = 'displayFoldedCardsEnabled',
  AllInEquityValueEnabled = 'allInEquityValueEnabled',
  SoundEnabled = 'soundEnabled',
  ModelsEnabled = 'modelsEnabled',
  StepInBigBlindsEnabled = 'stepInBigBlindsEnabled',
  TableTabsInDesktopEnabled = 'tableTabsInDesktopEnabled',
  ButtonConfigurations = 'buttonConfigurations',
  Hotkeys = 'hotkeys',
  FannedCardsDisplayEnabled = 'fannedCardsDisplayEnabled',
  ShowRealNameEnabled = 'showRealNameEnabled',
}
